import { GLServiceBase, ServiceRoute } from "commonui";
import { IComponentObjectiveReportService } from "./interface";
import { ComponentRangeModel, UnitRangeQueryParamsModel } from "./model";

class ComponentObjectiveReportServiceClass extends GLServiceBase<any, any> implements IComponentObjectiveReportService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/versions" };

	getComponentsByUnitRange(
		startUnitId: number,
		endUnitId: number,
		queryParams: UnitRangeQueryParamsModel
	): Promise<ComponentRangeModel[]> {
		return this.get(`unitcontents/${startUnitId}/${endUnitId}`, queryParams);
	}
}

export const ComponentObjectiveReportService: () => IComponentObjectiveReportService = () =>
	new ComponentObjectiveReportServiceClass();
